import { Tooltip } from "@mui/material";

export function TextTrimmer({ text, maxLength }: { text: string; maxLength: number }) {
  if (text.length <= maxLength) {
    return text;
  }
  const trimmedText = text.slice(0, maxLength).trim() + "...";
  return <Tooltip title={text}>{<span>{trimmedText}</span>}</Tooltip>;
}
